import * as types from './mutations_types'
export default {
  updatePageInfo: ({commit}, pageInfo) => {
    commit(types.UPDATE_PAGE_INFO, pageInfo)
  },
  updateUserInfo: ({commit}, userInfo) => {
    console.log('updateUserInfo: ', userInfo)
    commit(types.UPDATE_USER_INFO, userInfo)
  }
}



// WEBPACK FOOTER //
// ./src/store/global/actions.js